import { render, staticRenderFns } from "./MyCustom.vue?vue&type=template&id=df224edc&scoped=true"
import script from "./MyCustom.vue?vue&type=script&lang=js"
export * from "./MyCustom.vue?vue&type=script&lang=js"
import style0 from "./MyCustom.vue?vue&type=style&index=0&id=df224edc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df224edc",
  null
  
)

export default component.exports